// extracted by mini-css-extract-plugin
export default {"saudacao":"header_saudacao__j0UtP","App":"header_App__2TBaB"};